<template>
  <div class="message-actions-placeholder-container">
    <iRow wrap="nowrap">
      <iEditor />
      <iButton>Send Message</iButton>
    </iRow>
  </div>
</template>

<script>
// `%/components/community/chatrooms/...` lives outside the editor
// directory tree and `dynamic-component-editor/stores/conversation-store`
// is fully commented out → useConversationStore is undefined. Canvas
// preview renders the same placeholder UI the original showed in
// edit mode without crossing the boundary.
import {
  ChatRoomPageElementMixin,
} from "%/dynamic-component-editor/standard-pages/chat-room-page/chat-room-page-element-mixin";

export default {
  name: "ChatRoomActions",
  mixins: [
    ChatRoomPageElementMixin,
  ],
  deprecated: true,
  elementPanelSettings: {
    displayName: "Chat Room Actions",
    displayIcon: "list",
    elementGroup: "chatRoomElements",
    elementType: "element",
  },
};
</script>

<style lang="scss" scoped>
.message-actions-placeholder-container {
  display: flex;
}
</style>
